import { Link } from "react-router-dom";
import { newsItems } from "@/mocks/news";

const typeStyle: Record<string, string> = {
  新闻: "bg-secondary-100 text-secondary-900",
  采访: "bg-accent-100 text-accent-900",
  活动预告: "bg-primary-100 text-primary-700",
};

export default function NewsPreview() {
  const latest = newsItems.slice(0, 6);

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <Link
        to={`/news/detail/${latest[0].id}`}
        className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-1"
      >
        <div className="relative h-52 w-full overflow-hidden">
          <img
            src={latest[0].cover}
            alt={latest[0].title}
            title={`${latest[0].title} - 娱乐资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-5">
          <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-medium ${typeStyle[latest[0].type]}`}>
            {latest[0].type}
          </span>
          <h3 className="mt-3 font-heading text-lg font-semibold leading-7 text-foreground-950 group-hover:text-primary-600">
            {latest[0].title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">
            {latest[0].summary}
          </p>
          <span className="mt-3 inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-calendar-line"></i>
            {latest[0].date}
          </span>
        </div>
      </Link>

      <div className="lg:col-span-2">
        <ul className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {latest.slice(1).map((item) => (
            <li key={item.id}>
              <Link
                to={`/news/detail/${item.id}`}
                className="group flex items-start gap-4 p-4 transition-colors hover:bg-background-100"
              >
                <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 娱乐资讯`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate font-medium text-foreground-900 group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-2 flex items-center gap-3 text-[11px] text-foreground-500">
                    <span className={`rounded-full px-2 py-0.5 font-medium ${typeStyle[item.type]}`}>
                      {item.type}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {item.date}
                    </span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}